import {ValidatorFn} from '@angular/forms';
import {isInteger, isNumeric} from './ControlValidators';

export function unitValidatorFactory(unit: string): ValidatorFn  {
  if (unit === 'szt.' || unit === 'kpl.') {
    return isInteger()
  }
  return isNumeric()
}
